/**
 * Whether the reader has asked their system to reduce motion.
 *
 * Guarded for a missing `window` and a missing `matchMedia`, because the charts render under
 * happy-dom in tests and the query is not implemented there.
 */
export const prefersReducedMotion = (): boolean =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;
